import React, { useEffect, useRef, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { authAPI } from '../services/api';
import { Button } from '../components/Common/Button';
import { IconsLAccent01 } from '../components/Icons/Icons_L';
import { LoginBack, LoginHeader } from '../components/Common/Card';
import { IconContainer } from '../components/Common/Dialog';

import { Check, Clock, Cross } from '../components/Icons/CustomIcons';

/**
 * Seite, die aufgerufen wird, wenn der User auf den Bestätigungslink in der E-Mail klickt.
 * URL-Muster: /email-bestaetigen?token=<token>
 */

const EmailVerify = () => {
  const [searchParams] = useSearchParams();
  const [status, setStatus] = useState('loading'); // 'loading' | 'success' | 'error' | 'expired'
  const [message, setMessage] = useState('');
  const navigate = useNavigate();
  const hasVerified = useRef(false);

  useEffect(() => {
    if (hasVerified.current) return;
    hasVerified.current = true;

    const token = searchParams.get('token');
    if (!token) {
      setStatus('error');
      setMessage('Kein Bestätigungstoken gefunden. Bitte klicken Sie erneut auf den Link in Ihrer E-Mail.');
      return;
    }

    const verify = async () => {
      try {
        const response = await authAPI.verifyEmail(token);
        setMessage(response.data.message || 'E-Mail-Adresse erfolgreich bestätigt.');
        setStatus('success');
      } catch (err) {
        const data = err.response?.data;
        if (err.response?.status === 400 && data?.error?.includes('abgelaufen')) {
          setStatus('expired');
          setMessage(data.error);
        } else {
          setStatus('error');
          setMessage(data?.error || 'Ungültiger oder bereits verwendeter Bestätigungslink.');
        }
      }
    };

    verify();
  }, [searchParams]);

  const bgStyle = {
    backgroundImage: `url(${process.env.PUBLIC_URL}/GrosselternMitKindern.png)`,
  };

  const IconMain = ({ Icon }) => (
    <div style={{ display: 'flex', justifyContent: 'center', marginBottom: '0.75rem' }}>
      <div style={{ position: 'relative', display: 'inline-flex', alignItems: 'center', justifyContent: 'center' }}>
        <IconsLAccent01 size={84} />
        <Icon size={28} color="#fff" style={{ position: 'absolute' }} />
      </div>
    </div>
  );

  return (
    <div className="auth-fullpage" style={bgStyle}>
      <LoginBack returnTo="/" /> 
      <div>   
        <LoginHeader
          title="E-Mail-Adresse bestätigen"
          subtitle="Bitte warten Sie, während wir Ihre E-Mail-Adresse prüfen."
        />
      </div>
      <div className="auth-fullpage-panel">
        <div className="auth-panel-body">
          {status === 'loading' && (
            <div className="ml-success">
              <div className="ml-success-icon">⏳</div>
              <h2 className="ml-success-title">Bestätigung wird geprüft…</h2>
            </div>
          )}

          {status === 'success' && (
            <div className="ml-success">
              <IconMain Icon={Check} />
              <h2 className="ml-success-title">E-Mail bestätigt!</h2>
              <p>{message}</p>
              <Button className="w-full" onClick={() => navigate('/anmelden')}>
                Jetzt anmelden
              </Button>
            </div>
          )}

          {(status === 'error' || status === 'expired') && (
            <div className="ml-success">
              {status === 'expired' ? <IconMain Icon={Clock} /> : <IconMain Icon={Cross} />}
              

              <h2 className="ml-success-title">
                {status === 'expired' ? 'Link abgelaufen' : 'Bestätigung fehlgeschlagen'}
              </h2>
              <p className="ml-success-hint">{message}</p>
              <Button variant="outline" className="w-full" onClick={() => navigate('/anmelden?tab=registrieren')}>
                Erneut registrieren
              </Button>
              <Button className="w-full" onClick={() => navigate('/anmelden')}>
                Jetzt anmelden
              </Button>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default EmailVerify;
